import Repository from "./Repository";

const STATION = "stations/";

export default {
  getStation(payload) {
    return Repository.get(`${STATION}${payload}`);
  },
};
